import React, { useState, useEffect } from 'react';
import  DBFetch  from "../utils/dbFetch";
import axios from "axios";
import { SwitchTransition, CSSTransition } from "react-transition-group";

import ZoneTop from './Zone/ZoneTop';
import ZoneContent from './Zone/ZoneContent';

export default function Zone({ match, location }) {
    const region = match?.params?.region ? match.params.region : null;
    /*
    const [ state, setState ] = useState(false);
    useEffect(() => {
      setState(!state);
    }, [location]);
    */
    const [parentId, setParentId] = useState(null);
    const [children, setChildren] = useState(null);

    let page = DBFetch(
        process.env.REACT_APP_API+'pages?slug='+
            region +
            '&_embed'
    );
    let contenu = DBFetch(
        process.env.REACT_APP_API+'pages?slug='+region
    );


    useEffect(() => {
        contenu && setParentId(contenu[0]?.id);
    }, [contenu]);

    useEffect( () => {
      const fetchData = async (parentId) => {
          const url = process.env.REACT_APP_API+'pages?parent='+parentId+'&children&_embed&orderby=menu_order&order=asc';
          const response = await axios(url);
          const posts = await response;

          setChildren(
            posts.data?.map(item => [{
                'id': item.id,
                'media': item._embedded["wp:featuredmedia"] ? item._embedded["wp:featuredmedia"][0].media_details?.sizes.full?.source_url : '',
                'credit': item._embedded["wp:featuredmedia"] ? item._embedded["wp:featuredmedia"][0].alt_text : '',
                'title': item.title.rendered,
                'textSuite': item?.acf['textSuite'],
                'desc': item.content.rendered
            }])
          )
          // return posts && posts.data;
      }

        let data = parentId ? fetchData(parentId) : null;

        data?.length > 0  ?
          setChildren(
              data?.map(item => [
                  {
                      'id': item.id,
                      'media': item._embedded["wp:featuredmedia"] ? item._embedded["wp:featuredmedia"][0].media_details?.sizes.medium?.source_url : '',
                      'credit': item._embedded["wp:featuredmedia"] ? item._embedded["wp:featuredmedia"][0].alt_text : '',
                      'title': item.title.rendered,
                      'textSuite': item?.acf['textSuite'],
                      'desc': item.content.rendered
                  }
              ])
          )
          :
          null ;
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [parentId]);
   // children && console.log('children', children);
    return (
        <div id="zone" className="zone__container container-fluid p-0">
            <ZoneTop page= { page } region={region} />
            <ZoneContent page= { page } children= { children && children } region={ region } />
        </div>
    );
}
